import type { DateTime } from "@bounce/date"

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }

export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Date: string
  DateTime: string
  Json: any
}

export enum DisplayStatus {
  Closed = "CLOSED",
  ClosedAtCheckIn = "CLOSED_AT_CHECK_IN",
  ClosedAtCheckOut = "CLOSED_AT_CHECK_OUT",
  MaxDaysExceeded = "MAX_DAYS_EXCEEDED",
  Open = "OPEN",
  OutOfCapacity = "OUT_OF_CAPACITY",
}

export type Tag = {
  colorHex?: Maybe<Scalars["String"]>
  key?: Maybe<Scalars["String"]>
  name?: Maybe<Scalars["String"]>
  weight?: Maybe<Scalars["Int"]>
}

export type StoreHoliday = {
  country?: Maybe<Scalars["String"]>
  date?: Maybe<Scalars["Date"]>
  id?: Maybe<Scalars["String"]>
  name?: Maybe<Scalars["String"]>
  states?: Maybe<Maybe<Scalars["String"]>[]>
  types?: Maybe<Maybe<Scalars["String"]>[]>
}

export type StoreOpeningHourExceptions = Maybe<
  Maybe<{
    closeTime?: Maybe<Scalars["String"]>
    closed?: Maybe<Scalars["Boolean"]>
    endDate?: Maybe<Scalars["Date"]>
    holidayId?: Maybe<Scalars["String"]>
    id?: Maybe<Scalars["String"]>
    openTime?: Maybe<Scalars["String"]>
    reason?: Maybe<Scalars["String"]>
    startDate?: Maybe<Scalars["Date"]>
  }>[]
>

export type StoreOpeningHours = Maybe<
  Maybe<{
    closeTime?: Maybe<Scalars["String"]>
    dayOfWeek?: Maybe<Scalars["Int"]>
    openTime?: Maybe<Scalars["String"]>
  }>[]
>

export type StoreWithNickname = {
  nickname?: Maybe<Scalars["String"]>
  type?: Maybe<Scalars["String"]>
}

export type StoreWithName = {
  name?: Maybe<Scalars["String"]>
}

export enum OpeningStatus {
  IsOpenNow = "IS_OPEN_NOW",
  IsOpen = "IS_OPEN",
  IsClosed = "IS_CLOSED",
  IsClosedAtCheckIn = "IS_CLOSED_AT_CHECK_IN",
  IsClosedAtCheckOut = "IS_CLOSED_AT_CHECK_OUT",
  OutOfCapacity = "OUT_OF_CAPACITY",
  MaxDaysExceeded = "MAX_DAYS_EXCEEDED",
  Open24 = "OPEN_24",
}

export type HolidayWithConfirmationInfo = {
  isConfirmed: boolean
} & StoreHoliday

export type OpeningHours = {
  openTime?: string
  closeTime?: string
  dayOfWeek?: number
  holiday?: HolidayWithConfirmationInfo
  closed: boolean
}

export type OpeningHoursException = {
  id?: string
  openTime?: string | null
  closeTime?: string | null
  closed: boolean
  startDate: DateTime
  endDate: DateTime
  reason: string
  holidayId?: string
}

export type OpeningInfo = {
  status: OpeningStatus
  text: string
  extra: string | null
  color: string
  openingHours: OpeningHours[]
  openingHourExceptions: OpeningHoursException[]
  checkIn: {
    date: DateTime
    openingHours: OpeningHours[]
  }
  checkOut: {
    date: DateTime
    openingHours: OpeningHours[]
  }
}

export enum ReviewSourceType {
  Gmb = "GMB",
  InApp = "IN_APP",
}
